import React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import Spacer from '~/components/Spacer'
import DesktopContainer from '~/components/DesktopContainer'
import Success from '~/components/Success'
import WhatsNextDesktop from './WhatsNext/Desktop'
import WhatsNextMobile from './WhatsNext/Mobile'

const HeaderContainer = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  font-size: ${props => (props.isMobile ? '1.4rem' : '1.5rem')};
  color: ${props => props.color};
  text-align: center;
`

@inject(all => ({
  isMobile: all.store.ui.isMobile
}))
@observer
class FightSuccess extends React.Component {
  render() {
    return (
      <DesktopContainer>
        <Spacer mobile={25} desktop={30} />
        <Success />
        <Spacer mobile={10} desktop={10} />
        <HeaderContainer>
          What will happen next
        </HeaderContainer>
        <Spacer mobile={28} desktop={55} />
        {this.props.isMobile ? <WhatsNextMobile /> : <WhatsNextDesktop />}
        <Spacer mobile={28} desktop={55} />
      </DesktopContainer>
    )
  }
}

export default FightSuccess